














import Vue from 'vue'
import appInformation from '@/features/information-application/components/app-information.vue'
import router from '../../router'
import AppLayout from "@/components/app-layout.vue";
import $inoe from "@/config";
import { mapGetters } from 'vuex';
import store from "@/store";

export default Vue.extend({
data() {
    return {
        // Recuperation de la version de l'application Mobi a partir de la config
        version : " VERSION DE L'APPLICATION MOBI : " +$inoe.getVersionAppMobi(), 
    }
},
components :  {
    AppLayout,
    appInformation
},
computed : {
  ...mapGetters("etablissements", [
      "getCurrentEtablissement"
    ])
},
})
